import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/ChangeCircle";
import CheckCircle from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditDocumentIcon from "@mui/icons-material/EditDocument";
import { Modal } from "react-bootstrap";
import Button from "../../../../components/Button";
import "../../Common/form.css";
import api from "../../../../api/api";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import BackButton from "../../../../components/BackButton";
 
function UploadDocuments() {
  const { id: enq_id } = useParams();
  const navigate = useNavigate();
  const [files, setFiles] = useState({});
  const [errors, setErrors] = useState({});
  const [globalError, setGlobalError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
 
  const documentList = [
    {
      name: "Commercial Invoice",
      label: "Commercial Invoice",
      icon: <FileCopyIcon color="primary" fontSize="large" />,
    },
    {
      name: "Packing_List",
      label: "Packing List",
      icon: <LocalPostOfficeIcon color="primary" fontSize="large" />,
    },
    {
      name: "Product_Catalogue",
      label: "Product Catalogue (If Available)",
      icon: <ProductionQuantityLimitsIcon color="primary" fontSize="large" />,
    },
    {
      name: "Certification_For_Exporting",
      label: "Certification For Exporting",
      icon: <ImportExportIcon color="primary" fontSize="large" />,
    },
    {
      name: "Certification_For_Importing",
      label: "Certification For Importing",
      icon: <ImportExportIcon color="primary" fontSize="large" />,
    },
    {
      name: "Shipping_Bill",
      label: "Last Shipping Bill Copy (If Exports)",
      icon: <LocalShippingIcon color="primary" fontSize="large" />,
    },
    {
      name: "boe",
      label: "Last BOE (Bill Of Entry If Imports)",
      icon: <LocalAtmIcon color="primary" fontSize="large" />,
    },
    {
      name: "cha_auth",
      label: "CHA Authorization Letter",
      icon: <MailOutlineIcon color="primary" fontSize="large" />,
    },
    {
      name: "Endorsed_Copy_Of_BL",
      label: "Endorsed Copy of BL (If Imports)",
      icon: <ContentCopyIcon color="primary" fontSize="large" />,
    },
    {
      name: "si",
      label: "SI (If Exports)",
      icon: <DomainVerificationIcon color="primary" fontSize="large" />,
    },
    {
      name: "vgm",
      label: "VGM (If Exports)",
      icon: <DomainVerificationIcon color="primary" fontSize="large" />,
    },
  ];
 
  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    if (!file) return;
 
    if (file.type !== "application/pdf") {
      setErrors((prev) => ({ ...prev, [name]: "Only PDF files are allowed!" }));
      e.target.value = "";
      return;
    }
 
    setErrors((prev) => ({ ...prev, [name]: "" }));
    const fileWithPreview = { file, preview: URL.createObjectURL(file) };
    setFiles((prev) => ({ ...prev, [name]: fileWithPreview }));
  };
 
  const handleDelete = (name) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setFiles((prev) => {
      const updated = { ...prev };
      if (updated[name]?.preview) URL.revokeObjectURL(updated[name].preview);
      delete updated[name];
      return updated;
    });
  };
 
  const validate = () => {
    if (Object.keys(files).length === 0) {
      setGeneralError("At least one document must be uploaded.");
      return false;
    }
    setGeneralError("");
    return true;
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setShowConfirmModal(true);
  };
 
  const confirmSubmit = async () => {
    setShowConfirmModal(false);
 
    const formData = new FormData();
    formData.append("enq_id", enq_id);
    Object.keys(files).forEach((key) => {
      formData.append(key, files[key].file);
    });
 
    try {
      console.log("Uploading documents for enq_id:", enq_id);
      console.log("Files being sent:", Object.keys(files));
 
      const res = await api.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
 
      if (res.status === 200) {
        setShowSuccessModal(true);
        Object.values(files).forEach((f) => URL.revokeObjectURL(f.preview));
        setFiles({});
        setErrors({});
        document.getElementById("uploadForm").reset();
      } else {
        setGeneralError("Upload failed. Please try again.");
      }
    } catch (err) {
      console.error("❌ Error uploading documents:", err);
      setGeneralError("Error uploading documents. Please try again.");
    }
  };
 
  const handleSuccessOk = () => {
    setShowSuccessModal(false);
    navigate("/my-bookings/list-of-bookings");
  };
 
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://jgyuubub.blob.core.windows.net/booking-documents/CHA_Authorization_Letter.pdf?sv=2025-05-05&st=2025-07-21T17%3A27%3A34Z&se=2030-07-20T17%3A27%3A34Z&sr=b&sp=r&sig=%2BPGVF4f71NV3qcI5MK3KdCJUdYKthK8AUffupTM3BFw%3D&response-content-disposition=attachment%22%22";
    link.download = "CHA_Authorization_Letter.pdf";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
 
  return (
    <>
    <BackButton />
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="d-flex align-items-center">
         
          <h6 className="mb-1 fw-semibold">
            <EditDocumentIcon /> Download CHA Authorization Letter and upload it
            with signature and stamp.
          </h6>
        </div>
 
        <div className="d-flex align-items-center gap-2">
          <Button
            color="white"
            fontSize="large"
            onClick={handleDownload}
            text="Download"
            btncls="px-5 "
          />
        </div>
      </div>
 
      <div className="mb-4">
        <p className="fw-bold text-dark">
          Note: Only PDF files are supported for upload.
        </p>
      </div>
      <form id="uploadForm" onSubmit={handleSubmit}>
        <div className="five-col-grid d-grid">
          {documentList.map((doc, idx) => (
            <div className="card h-100 shadow-sm border-0 upload-card text-center p-3">
              <div className="icon-box mx-auto mb-2">
                <span className="iconouter d-flex align-items-center justify-content-center">
                  {doc.icon}
                </span>
              </div>
              {/* Hidden file input */}
              <input
                type="file"
                id={`file-${doc.name}`}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e, doc.name)}
                accept="application/pdf"
              />
 
              {/*  Invoice label (now above) */}
              <span className="text-dark mt-2 fw-semibold">{doc.label}</span>
 
              {/*  Click to Upload (now below) */}
              <span
                className="text-muted fw-semibold uploaddoc"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  document.getElementById(`file-${doc.name}`).click()
                }
              >
                {files[doc.name] ? "Change File" : "Click to Upload"}
              </span>
 
              {errors[doc.name] && (
                <p className="text-danger small mt-2 mb-0">
                  {errors[doc.name]}
                </p>
              )}
 
              {files[doc.name] && (
                <div className="mt-3 text-success small d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <CheckCircleIcon fontSize="small" className="me-1" />
                    <span
                      className="uploaded-file-name"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(files[doc.name].preview, "_blank")
                      }
                    >
                      {files[doc.name].file.name}
                    </span>
                  </div>
                  <DeleteIcon
                    style={{ cursor: "pointer", color: "#1d3160" }}
                    onClick={() => handleDelete(doc.name)}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
 
        {globalError && (
          <p className="text-danger fw-bold mt-3">{globalError}</p>
        )}
 
        <div className="d-flex justify-content-end mt-4">
          <button type="submit" className="btn btn-primary py-2 w-40">
            Submit Documents
          </button>
        </div>
      </form>
 
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to upload these documents?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmSubmit}>
            Yes, Upload
          </Button>
        </Modal.Footer>
      </Modal>
 
      <Modal show={showSuccessModal} onHide={handleSuccessOk} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Documents uploaded successfully!</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleSuccessOk}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default UploadDocuments;
 